const isDemo = process.env.REACT_APP_THEME === 'demo';

const styles = () => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 24,
    paddingRight: 24,
    height: '100%',
    position: 'relative',
    fontFamily: isDemo ? 'inherit' : 'Questrial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    margin: 'auto',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
  },
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16,
  },
  campusSelect: {
    minWidth: 220,
    marginRight: 16,
  },
  tableContainer: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
  headerActions: {
    display: 'flex',
    gap: 12,
  },
  studentNameCell: {
    cursor: 'pointer',
    fontWeight: 600,
    color: '#1976d2',
  },
  excludedName: {
    textDecoration: 'line-through',
    color: '#9e9e9e',
  },
  aepBadge: {
    marginLeft: 8,
  },
  emptyState: {
    padding: 24,
    color: '#656565',
  },
  detailWrapper: {
    marginTop: 12,
  },
});

export default styles;
